import { useEffect, useMemo, useState } from 'react'
import { useDispatch, useSelector } from 'react-redux'
import { RootState } from '../../../redux'
import stepSlice from '../../../redux/slice/steps.slice'
import { SessionsPerCampers } from '../../../types/libertyLake'
import appSlice from '../../../redux/slice/app.slice'
import axios from 'axios'
import { config } from '../../../config'

interface EachCamperSessions {
  allSessions: string[]
  grade: string
}

const Footer = () => {
  const dispatch = useDispatch()
  const { step, campers, sessionsPerCampers, addonsMap, familyInfo } = useSelector((state: RootState) => state.steps)

  const MIN_WEEKS_PER_CAMPER = 2
  const [footerErrorMsg, setFooterErrorMsg] = useState('')

  const returnToWebsite = () => {
    window.location.assign('https://libertylakedaycamp.com/about-us-2/')
  }

  const getAddonsCost = () => {
    let total = 0
    sessionsPerCampers.forEach(s => {
      let eachCamperAddonCost = 0
      s.addons.forEach(sAdd => {
        if (addonsMap) {
          eachCamperAddonCost += addonsMap[sAdd].price * s.weeks.length
        }
      })
      total += eachCamperAddonCost
    })

    return total
  }

  const isStepOneValid = (): boolean => {
    if (
      campers.length > 0 &&
      familyInfo.firstName.length &&
      familyInfo.lastName.length &&
      familyInfo.email.length // Phone Number Field is optional
    ) {
      return true
    }
    return false
  }

  const isStepTwoValid = (): boolean => {
    const eachSessionValidity: boolean[] = []
    sessionsPerCampers.forEach((sessionPerCamper: SessionsPerCampers) => {
      if (sessionPerCamper.grade.length && sessionPerCamper.weeks.length >= MIN_WEEKS_PER_CAMPER) {
        eachSessionValidity.push(true)
      } else {
        eachSessionValidity.push(false)
      }
    })

    if (eachSessionValidity.every((value: boolean) => value === true)) {
      return true
    }
    return false
  }

  const isStepThreeValid = (): boolean => {
    if (
      familyInfo.firstName.length &&
      familyInfo.lastName.length &&
      familyInfo.email.length &&
      familyInfo.occupation.length // Phone Number Field is optional
    ) {
      return true
    }
    return false
  }

  const isStepValid = () => {
    if (step === 1 && isStepOneValid()) {
      return true
    } else if (step === 2 && isStepTwoValid()) {
      return true
    } else if (step === 3 && isStepThreeValid()) {
      return true
    } else if (step === 4) {
      return true
    }

    return false
  }

  const step2ValidationMessage = useMemo(() => {
    if (step !== 2) return ''

    const hasAnyMissingGrade = sessionsPerCampers.some(s => !s.grade?.length)
    if (hasAnyMissingGrade) return 'Please select a grade for each camper.'

    const hasAnyUnderMinWeeks = sessionsPerCampers.some(s => (s.weeks?.length || 0) < MIN_WEEKS_PER_CAMPER)
    if (hasAnyUnderMinWeeks) return 'Camper must be registered for at least 2 weeks.'

    return ''
  }, [MIN_WEEKS_PER_CAMPER, sessionsPerCampers, step])

  useEffect(() => {
    if (step !== 2) {
      setFooterErrorMsg('')
      return
    }
    if (footerErrorMsg && isStepTwoValid()) {
      setFooterErrorMsg('')
    }
  }, [footerErrorMsg, step, sessionsPerCampers])

  const nextClickHandler = () => {
    if (step === 1 && isStepOneValid()) {
      dispatch(stepSlice.actions.setStepNumber(step + 1))
    } else if (step === 2) {
      if (!isStepTwoValid()) {
        setFooterErrorMsg(step2ValidationMessage || 'Camper must be registered for at least 2 weeks.')
        return
      }
      setFooterErrorMsg('')
      dispatch(stepSlice.actions.setStepNumber(step + 1))
    } else if (step === 3 && isStepThreeValid()) {
      const camperAndSessions: EachCamperSessions[] = []
      sessionsPerCampers.forEach(sessionsPerCamper => {
        camperAndSessions.push({
          allSessions: sessionsPerCamper.weeks,
          grade: sessionsPerCamper.grade
        })
      })
      const data = {
        firstName: familyInfo.firstName,
        lastName: familyInfo.lastName,
        email: familyInfo.email,
        city: familyInfo.city,
        phoneNumber: familyInfo.phone ?? '',
        numberOfCampers: campers.length,
        camperAndSessions,
        subTotal: familyInfo.familySessionsCost,
        discounts: familyInfo.totalFamilyDiscount,
        addonsCost: getAddonsCost(),
        grandTotal: familyInfo.grandTotalFamilyCost + getAddonsCost()
      }
      dispatch(appSlice.actions.setLoading(true))
      axios({
        method: 'POST',
        url: config.libertyLakeWorkflowURL,
        headers: { 'Cache-Control': 'no-cache' },
        data
      })
        .then(res => console.log(res))
        .catch(err => console.log(err))

      dispatch(appSlice.actions.setLoading(false))
      dispatch(stepSlice.actions.setStepNumber(step + 1))
    }
  }

  return <div className='footerContainer'>
    <div className="buttonContainer">
      {step === 2 && footerErrorMsg.length > 0 && (
        <div className='footerValidationText'>
          {footerErrorMsg}
        </div>
      )}
      {step > 1 && (
        <button
          className="back"
          onClick={() => dispatch(stepSlice.actions.setStepNumber(step - 1))}
        >
          Previous
        </button>
      )}
      {step === 4 && (
        <button
          type="button"
          className="returnToWebsite"
          onClick={returnToWebsite}
        >
          Return to website
        </button>
      )}
      <button
        className={`next ${step >= 4 && 'hide'}`}
        disabled={(step !== 2 && !isStepValid()) || step === 4}
        onClick={() => nextClickHandler()}
      >
        Next
      </button>
    </div>
  </div>
}

export default Footer
